import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './public-path.js';
import { PersistGate } from 'redux-persist/integration/react';
import { LocaleProvider } from 'zarm';
import localesZh_CN from 'zarm/lib/locale-provider/locale/zh_CN';
import { ConfigProvider } from 'zarm-v3';
import { AliveScope } from 'react-activation'; // 引入 AliveScope
import configureStore from './configureStore';
import Routes from './pages/routes';
// MonitorJS 初始化已迁移至 HTML 模板 (views/index-rsbuild.html)
// 导入 initMonitor 以自动执行微信会话观测 SDK 初始化
import './utils/initMonitor';
import './utils/loadThirdSDK';

// 启用权益页面的mock数据
// import { enableMock } from './pages/personalCenter/myRights/fetchMock';
// enableMock();

const { Store, Persistor } = configureStore;

const APP_DOM = document.getElementById('app') as HTMLElement;

ReactDOM.render(
  <Provider store={Store}>
    <PersistGate loading={null} persistor={Persistor}>
      <LocaleProvider locale={localesZh_CN}>
        <ConfigProvider prefixCls='zarm-v3'>
          <AliveScope>
            <Routes />
          </AliveScope>
        </ConfigProvider>
      </LocaleProvider>
    </PersistGate>
  </Provider>,
  APP_DOM
);
